import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import NewRirekishoResetDialog from '@/components/format-edit/new-rirekisho/NewRirekishoResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/gradeYearOptions.json'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoEduHistoryCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null
  },
  setup(__props: any) {

const descriptionMaxLength = 80



const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  setEducationalBackgrounds,
  resetEducationalBackgrounds,
  addEducationalHistory,
  deleteEducationalHistory,
  moveEducationalHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const educationalResetVisible = ref(false)

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, setEducationalBackgrounds, resetEducationalBackgrounds, addEducationalHistory, deleteEducationalHistory, moveEducationalHistory, activateHistoryItem, educationalResetVisible, HistoryItem, AutoEducationalBackgrounds, NewRirekishoResetDialog, gradeYearOptions }
}

})